<template>
  <div class="page-wrapper">
    <main class="main">
      <nav class="breadcrumb-nav">
        <div class="container">
          <ul class="breadcrumb bb-no">
            <li>
              <router-link to="/">{{ $yuyanbao.shouye }}</router-link>
            </li>
            <li>
              {{ duoyuyan(leixing) }}
            </li>
          </ul>
        </div>
      </nav>

      <div class="page-content mb-10">
        <div class="container">
          <div class="main-content">
            <div
              class="shop-default-banner shop-boxed-banner banner d-flex align-items-center mb-6 br-xs"
              style="background-color: #ffc74e"
              :style="{
                backgroundImage: 'url(' + $shezhi.shoptupian + ')',
              }"
            >
              <div class="banner-content">
                <h3
                  class="banner-title text-white text-uppercase font-weight-bolder ls-10"
                >
                  {{ duoyuyan(leixing) }}
                </h3>
              </div>
            </div>
          </div>
          <div class="shop-default-category category-ellipse-section mb-6">
            <div
              style="overflow: scroll"
              class="swiper-container swiper-theme shadow-swiper swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
            >
              <div
                class="swiper-wrapper"
                style="transform: translate3d(0px, 0px, 0px)"
              >
                <div
                  v-for="(item, index) in leixings"
                  :key="index"
                  class="category-wrap"
                  style="width: 128px; margin-right: 30px; flex-shrink: 0"
                >
                  <div class="category">
                    <figure class="category-media">
                      <router-link
                        :to="{
                          path: '/boutiques',
                          query: {
                            ukey: item.ukey,
                          },
                        }"
                      >
                        <img
                          :src="item.tupian || $tupianmoren"
                          alt=""
                          width="128"
                          height="128"
                          style="background-color: #5c92c0"
                        />
                      </router-link>
                    </figure>
                    <div class="category-content">
                      <h4 class="category-name">
                        <router-link
                          :to="{
                            path: '/boutiques',
                            query: {
                              ukey: item.ukey,
                            },
                          }"
                        >
                          {{ duoyuyan(item) }}
                        </router-link>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="shop-content row gutter-lg mb-10">
            <div class="main-content" style="max-width: none !important">
              <div class="product-wrapper row cols-md-3 cols-sm-2 cols-1">
                <div
                  class="product-wrap"
                  v-for="(item, index) in gongsis"
                  :key="index"
                >
                  <div class="product text-center">
                    <figure class="product-media">
                      <router-link
                        :to="{ path: '/boutique', query: { ukey: item.ukey } }"
                      >
                        <img
                          :src="item.banner || $tupianmoren"
                          alt=""
                          width="300"
                          height="338"
                        />
                      </router-link>
                      <div
                        class="product-action-horizontal pointer"
                        @click="
                          $router.push({
                            path: '/boutique',
                            query: { ukey: item.ukey },
                          })
                        "
                      >
                        {{ item.dianhua }}
                        <br />
                        {{ item.email }}
                      </div>
                    </figure>
                    <div class="product-details">
                      <div class="product-cat">
                        <router-link
                          :to="{
                            path: '/boutique',
                            query: { ukey: item.ukey },
                          }"
                        >
                          {{ duoyuyan(item) }}
                        </router-link>
                      </div>
                      <h3 class="product-name">
                        <router-link
                          :to="{
                            path: '/boutique',
                            query: { ukey: item.ukey },
                          }"
                        >
                          {{ duoyuyan(item, "miaoshu") }}
                        </router-link>
                      </h3>
                      <div class="product-pa-wrapper">
                        <div class="product-price">
                          {{ item.codepostal }} {{ item.chengshi }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { getGongSiLeiXing, getGongSi } from "@/api/gongsi";

export default {
  name: "Boutiques",
  components: {},
  watch: {
    $route(to, from) {
      if (to.query.ukey != from.query.ukey) {
        this.ukey = to.query.ukey;
        this.get_gongsi_leixing_http();
      }
    },
  },
  data() {
    return {
      ukey: "",
      leixings: [],
      leixing: {},
      gongsis: [],
      gongsi: {},
    };
  },
  mounted() {
    this.ukey = this.$route.query.ukey;
    this.get_gongsi_leixing_http();
  },

  methods: {
    get_gongsi_http() {
      getGongSi({ leixing: this.leixing.id }).then((data) => {
        if (data.status === "SUCCESSED") this.gongsis = data.data;
      });
    },
    get_gongsi_leixing_http() {
      getGongSiLeiXing().then((data) => {
        if (data.status === "SUCCESSED") {
          this.leixings = data.data;
          for (let i = 0, len = this.leixings.length; i < len; i += 1) {
            if (this.leixings[i].ukey === this.ukey) {
              this.leixing = JSON.parse(JSON.stringify(this.leixings[i]));
              this.get_gongsi_http();
              break;
            }
          }
        }
      });
    },
  },
};
</script>
